import { emitter, router } from '@codesuma/baseline'
import services from './services'
import list from './services/list'
import listsService from './services/lists'
import seed from './services/seed'
import font from './services/font'
import theme from './services/theme'
import push from './services/push'
import deeplinks from './services/deeplinks'
import invites from './services/invites'
import { App } from './app'

window.onerror = (message) => alert(message)

// Web OAuth marker — capture the return path before Supabase (detectSessionInUrl)
// strips ?code from the URL asynchronously. Used below to repair the back stack.
const oauthReturnPath = new URLSearchParams(location.search).has('code') ? location.pathname : null

// Apply the saved font + theme before first paint so there's no flash of the default.
font.init()
theme.init()

// init()
document.body.appendChild(App().el)

// Native status bar style is set by the theme service (theme.init above) to suit
// the active light/dark background.
const cap = (window as any).Capacitor
if (cap?.isNativePlatform?.()) {
    // Route the Android system back gesture/button through the app's router so it
    // navigates back with the app's own transition. The WebView's iOS-style
    // swipe-slide is suppressed separately via `overscroll-behavior` (index.html),
    // so back still works on a left-edge swipe — just without the foreign animation.
    cap.Plugins?.App?.addListener('backButton', () => {
        if (router.getPath() === '/') cap.Plugins?.App?.exitApp()
        else router.back()
    })
}

// DB initialization, then seed starter content on first run
services.db.init()
seed.run()

// Auth initialization (events are handled internally by supabase service)
services.supabase.auth.initialize()

// After a web OAuth redirect we land back on the page login was started from
// (e.g. /menu?code=…). Supabase clears the code from the current history entry,
// but the provider redirect plus the router's initial pushState leave a stale
// /menu?code entry behind it — so "back" returns to that code URL instead of home.
// Once auth is ready, rebuild a clean back stack: home behind, the return page
// current. (/login navigates itself after auth, so leave it alone.)
if (oauthReturnPath && oauthReturnPath !== '/login' && !cap?.isNativePlatform?.()) {
    services.supabase.auth.waitForInitialization().then(() => {
        history.replaceState(null, '', '/')
        history.pushState(null, '', oauthReturnPath)
    })
}

// Push notifications (native only): route notification taps and refresh the
// device token if permission was already granted. Never prompts here.
push.init()

// Verified https links (App/Universal Links, native only): route papalist.app
// URLs that opened the app — while running and on cold start.
deeplinks.init()

// Incoming share invites: check once and listen live (Realtime), so the
// "X shared a list with you" alert appears on whatever page is open.
invites.init()

// When coming back online, replay anything created offline (lists + items) and
// refresh from server
window.ononline = () => {
    emitter.emit('online')
    listsService.syncPending()
    list.replayPending().then(() => list.fetchFromServer())
}
